import remoteLogWithLevel from './remoteLogWithLevel'
import events from '../services/events'
const startTime = Date.now()

const defaultLoggerConfig = {
  logzioId: null,
  appName: 'n.a',
  appVersion: 'n.a',
  moduleName: 'general',
  loggerName: 'general',
  type: 'frontendapps',
  logLocally: true,
  logRemotely: false,
  // Temporal default level, will be debug after STUD-13963
  logLevel: 'info'
}

const levelsArray = ['debug', 'info', 'log', 'warn', 'error']

const listOfLoggers = []

const getListOfAvailableLogLevels = minLogLevel => levelsArray.slice(levelsArray.indexOf(minLogLevel || defaultLoggerConfig.logLevel))

events.on('log-level-changed', minLogLevel =>
  listOfLoggers.forEach(logger => {
    logger.availableLogLevels = getListOfAvailableLogLevels(minLogLevel)
  })
)

export const createLogger = (identity, data, config) => {
  const logger = new Logger(identity, data, config)

  logger.availableLogLevels = getListOfAvailableLogLevels(config.logLevel)
  listOfLoggers.push(logger)

  return logger
}

class Logger {
  constructor(identity, data, config) {
    this.identity = {
      moduleName: identity.moduleName || defaultLoggerConfig.moduleName,
      loggerName: identity.loggerName || defaultLoggerConfig.loggerName
    }
    this.data = data
    this.config = config
    this.localConsolePrefix = `[${this.identity.moduleName}|${this.identity.loggerName}]`
  }

  time = operationLabel => {
    const startTime = Date.now()
    const title = 'Operation measurement'
    let isExecuted = false
    return () => {
      if (isExecuted) {
        this.warn('This timer was called more than once')
        return
      }
      isExecuted = true
      const endTime = Date.now()
      const record = {operationLabel, operationTimeInMiliseconds: endTime - startTime}

      if (this.config.logLocally) {
        console.log(this.localConsolePrefix, title, record)
      }

      if (this.config.logRemotely) {
        const config = this.getRemoteLoggerConfig()

        remoteLogWithLevel('log', [title], {...config, ...record})
      }
    }
  }

  getRemoteLoggerConfig = () => {
    // eslint-disable-next-line no-unused-vars
    const {logRemotely, logLocally, logLevel, ...cleanConfig} = {
      ...defaultLoggerConfig,
      ...this.identity,
      ...this.config,
      ...this.data
    }

    return {
      ...cleanConfig,
      uptime: Date.now() - startTime
    }
  }

  logWithLevel = (level, ...args) => {
    if (!args[0]) {
      return
    }

    if (!this.availableLogLevels.includes(level)) {
      return
    }

    if (this.config.logLocally) {
      console[level](this.localConsolePrefix, ...args)
    }

    if (this.config.logRemotely) {
      const config = this.getRemoteLoggerConfig()

      remoteLogWithLevel(level, args, config)
    }
  }

  error = (...args) => this.logWithLevel('error', ...args)
  warn = (...args) => this.logWithLevel('warn', ...args)
  log = (...args) => this.logWithLevel('log', ...args)
  info = (...args) => this.logWithLevel('info', ...args)
  debug = (...args) => this.logWithLevel('debug', ...args)
}
